import classNames from "classnames";

import { ChallengeStudentFeedbackItem, translate } from "@ascendnow/shared";

import styles from "./AscChallengeFeedbackCard.module.scss";
import AscSelectInput from "../AscInputFields/AscSelectInput/AscSelectInput";
import AscAvatar from "../AscAvatar/AscAvatar";
import ProfilePicture from "../../assets/images/sample-avatar-1.png";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscChallengeFeedbackReward from "./AscChallengeFeedbackReward";
import AscAudioPlayer from "../AscAudioPlayer/AscAudioPlayer";

type ChallengeFeedbackAuthor = {
  id: string;
  name: string;
};

export type AscChallengeFeedbackCardProps = {
  feedback: ChallengeStudentFeedbackItem;
  feedbackAuthors?: ChallengeFeedbackAuthor[];
  onSelectAuthor?: (id: string) => void;
  loading?: boolean;
  className?: string;
};

export default function AscChallengeFeedbackCard({
  feedback,
  feedbackAuthors,
  onSelectAuthor,
  loading,
  className,
}: AscChallengeFeedbackCardProps) {
  return (
    <div
      data-testid="asc-challenge-feedback-card"
      className={classNames(
        styles.ground,
        { [styles.loading]: loading },
        className
      )}
    >
      {onSelectAuthor && feedbackAuthors && Array.isArray(feedbackAuthors) && (
        <div className={styles.teacherSelect}>
          <span className={styles.teacherSelectLabel}>
            {translate("chooseTeacherFeedback")}
          </span>
          <AscSelectInput value={feedback?.teacherName} showArrowIcon>
            {feedbackAuthors.map((author) => (
              <AscSelectInput.Option
                key={author?.id}
                value={author?.id}
                label={author?.name}
                onClick={() => onSelectAuthor(author?.id)}
              />
            ))}
          </AscSelectInput>
        </div>
      )}
      <div className={styles.challengeFeedbackAuthor}>
        <AscAvatar
          src={feedback?.profilePicture?.location ?? ProfilePicture}
          width={105}
          height={105}
          className={styles.avatar}
          alt="Feedback author avatar"
        />
        <AscHeading level={4}>{feedback?.teacherName || "-"}</AscHeading>
      </div>
      <div className={styles.challengeFeedbackContent}>
        <div className={styles.challengeFeedbackText}>
          <span className={styles.label}>{translate("feedback")}</span>
          <p className={styles.text}>{feedback?.feedbackText}</p>
        </div>
        {feedback?.audioFileUrl && (
          <AscAudioPlayer
            src={feedback?.audioFileUrl}
            label={translate("recorderFeedback")}
          />
        )}
        <div className={styles.challengeFeedbackRewards}>
          <span className={styles.label}>{translate("bonusRewards")}</span>
          <div className={styles.rewardContainer}>
            <AscChallengeFeedbackReward
              type="coins"
              value={feedback?.bonusCoins || 0}
            />
            <AscChallengeFeedbackReward
              type="points"
              value={feedback?.bonusPoints || 0}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
